import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawEnvelopeIcon from "./RawEnvelopeIcon.svg.jsx";

const EnvelopeIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawEnvelopeIcon} {...props} />;
});

export default EnvelopeIcon;
